import { Box, TableCell, TableRow } from '@mui/material';
import { FC } from 'react';

import { ReactComponent as EditIcon } from '../../../../assets/images/highlight.svg';
import { ReactComponent as DeleteIcon } from '../../../../assets/images/DeleteIcon.svg';
import TooltipTableCell from '../../../../components/formlib/TooltipTableCell';
import MediumTypography from '../../../../components/formlib/MediumTypography';
import ActionToolTip from '../../../../components/formlib/ActionToolTip';
import { OptionType } from '../../../../utils/type';
import { ServicePlanType } from '../../../../redux/features/ifsp/ifspSDPAndConsentSlice';
import { useAppSelector } from '../../../../redux/hooks';

interface IfspTable {
  data: ServicePlanType;
  dataLength: number;
  onEdit: () => void;
  onDelete: (id: string) => void;
  isIfspScreenLocked?: boolean;
  canEditAfterLock?: boolean;
  canDeleteAfterLock?: boolean;
  actionRequired: boolean;
  actionMode?: string;
  reasonIfLate: OptionType[];
  eiService: OptionType[];
  providedBy: OptionType[];
  locationOfService: OptionType[];
  period: OptionType[];
  intensity: OptionType[];
}

const ServiceDeliveryPlanTableRow: FC<IfspTable> = ({
  data,
  dataLength,
  onEdit,
  onDelete,
  isIfspScreenLocked,
  canEditAfterLock,
  canDeleteAfterLock,
  actionRequired,
  actionMode,
  reasonIfLate,
  eiService,
  intensity,
  locationOfService,
  providedBy,
  period,
}) => {
  let deleteCursor;

  if (data.tbrServicePlanId > 0 || isIfspScreenLocked || actionMode !== 'add') {
    deleteCursor = 'not-allowed';
  } else {
    deleteCursor = 'pointer';
  }

  const handleClick = () => {
    if (canDeleteAfterLock && dataLength > 1) {
      onDelete(data.id);
    } else if (
      data.tbrServicePlanId > 0 ||
      (data.endDate && data.reasonForLate) ||
      isIfspScreenLocked ||
      actionMode !== 'add'
    ) {
      return null;
    } else {
      onDelete(data.id);
    }
  };

  const ifspClientDetails = useAppSelector(
    (state) => state.ifspClientDetails.ifspClientDetails,
  );

  return (
    <TableRow
      sx={{
        backgroundColor:
          !ifspClientDetails.isServiceDeliveryChecked &&
          data.tbrUpdateRequired &&
          actionRequired
            ? '#FFE0C2'
            : 'inherit',
      }}
    >
      <TableCell>
        <TooltipTableCell
          value={
            eiService.find((item) => item.id === data.eiService)?.label ?? '-'
          }
          visible={true}
          tooltipSxProps={{
            borderBottom: '0px',
            padding: '0px',
          }}
        />
      </TableCell>
      <TableCell>
        <TooltipTableCell
          value={
            providedBy.find((item) => item.id === data.providedBy)?.label ?? '-'
          }
          visible={true}
          tooltipSxProps={{
            borderBottom: '0px',
            padding: '0px',
          }}
        />
      </TableCell>
      <TableCell>
        <TooltipTableCell
          value={
            locationOfService.find((item) => item.id === data.locationOfService)
              ?.label ?? '-'
          }
          visible={true}
          tooltipSxProps={{
            borderBottom: '0px',
            padding: '0px',
          }}
        />
      </TableCell>
      <TableCell>
        <TooltipTableCell
          value={`${data.frequency ?? '-'}x ${
            period.find((item) => item.id === data.period)?.label ?? '-'
          }, ${data.length ?? '0.00'}`}
          visible={true}
          tooltipSxProps={{
            borderBottom: '0px',
            padding: '0px',
          }}
        />
      </TableCell>
      <TableCell>
        <TooltipTableCell
          value={
            intensity.find((item) => item.id === data.intensity)?.label ?? '-'
          }
          visible={true}
          tooltipSxProps={{
            borderBottom: '0px',
            padding: '0px',
          }}
        />
      </TableCell>
      <TableCell>
        <TooltipTableCell
          value={data.durationOfService ?? '-'}
          visible={true}
          tooltipSxProps={{
            borderBottom: '0px',
            padding: '0px',
          }}
        />
      </TableCell>
      <TableCell>
        <MediumTypography label={data.startDate ? data.startDate : '-'} />
      </TableCell>
      <TableCell>
        <MediumTypography label={data.endDate ? data.endDate : '-'} />
      </TableCell>
      <TableCell>
        <TooltipTableCell
          value={
            reasonIfLate.find((item) => item.id === data.reasonForLate)
              ?.label ?? '-'
          }
          visible={true}
          tooltipSxProps={{
            borderBottom: '0px',
            padding: '0px',
          }}
        />
      </TableCell>
      {actionRequired && (
        <TableCell>
          <Box className="flex__ mt-xs">
            <Box className="mr-md">
              <ActionToolTip labelId="BlockTime.edit" defaultLabel="Edit">
                <EditIcon
                  cursor={
                    // data.endDate &&
                    // data.reasonForLate &&
                    isIfspScreenLocked && !canEditAfterLock
                      ? 'not-allowed'
                      : 'pointer'
                  }
                  onClick={() =>
                    // data.endDate &&
                    // data.reasonForLate &&
                    isIfspScreenLocked && !canEditAfterLock ? null : onEdit()
                  }
                />
              </ActionToolTip>
            </Box>
            <Box component="div">
              <ActionToolTip
                labelId="ConsentForms.listActionDeleteToolTipLabel"
                defaultLabel="Delete"
              >
                <DeleteIcon cursor={deleteCursor} onClick={handleClick} />
              </ActionToolTip>
            </Box>
          </Box>
        </TableCell>
      )}
    </TableRow>
  );
};

export default ServiceDeliveryPlanTableRow;
